export default __webpack_public_path__ + "static/media/Tedi M.a27efe47.png";